import React, { Component } from 'react'
import { FormattedMessage, injectIntl } from 'react-intl'
import { Box } from '@chakra-ui/react'
import { Content } from 'src/components/Layout'
import { TextArea } from 'src/components/Form'
import { Form, Field } from 'react-final-form'
import Button from 'src/components/Button/Button'
import intlMessages from '../translations'

class LocationOfflineForm extends Component {
  handleSubmit = values => {
    this.props.onSubmit(values)
  }

  validateFormFields = values => {
    const { intl } = this.props

    const errors = {}
    if (!values.locationText || !values.locationText.replace(/\s/g, '')) {
      errors.locationText = intl.formatMessage(intlMessages.locationValidationAddress)
    }

    return errors
  }

  render() {
    const { intl } = this.props

    return (
      <Content padder>
        <Form
          onSubmit={this.handleSubmit}
          validate={this.validateFormFields}
          render={({ handleSubmit }) => (
            <form onSubmit={handleSubmit}>
              <Field
                name='locationText'
                render={({ input, meta }) => (
                  <Box mb={5}>
                    <TextArea
                      name='locationText'
                      initialValue={this.props.locationText}
                      type='text'
                      error={meta}
                      placeholder={intl.formatMessage(intlMessages.locationPlaceholderAddress)}
                      {...input}
                    />
                  </Box>
                )}
              />
              <Button isFullWidth type='submit'>
                <FormattedMessage id='app.location.submit' defaultMessage='Submit' />
              </Button>
            </form>
          )}
        />
      </Content>
    )
  }
}

export default injectIntl(LocationOfflineForm)
